import { Component, OnInit } from '@angular/core';

import { Client } from 'src/providers/client/client';
import { Loading } from 'src/shared/components/loading/loading';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { TidyStorage } from 'src/shared/providers/tidy-storage';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { SuccessPage } from 'src/shared/pages/success/success';
import { PastJobPage } from 'src/pages/more/past-job/past-job';
import { SubscriptionsPage } from 'src/pages/subscription/subscription';
import { Util } from 'src/shared/util/util';
import { GetRefundPage } from '../get-refund/get-refund';
import { WindowService } from 'src/shared/providers/window.service';

@Component({
    templateUrl: 'billing-item-help.html',
    standalone: false
})

export class BillingItemHelpPage implements OnInit {

  item: any;
  isRightSideContent = true;
  dialogParams: any;

  constructor(
    private client: Client,
    private storage: TidyStorage,
    private util: Util,
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    private windowService: WindowService,
  ) {}

  async ngOnInit() {
    this.rightSidePanelService.setDialogPageTitle('Billing History');
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.dialogParams = await this.storage.retrieve('dialog-params');
    this.item = this.navCtrl.getParam('item') || this.dialogParams?.item;
  }

  goToCleaningDetails(cleaningId) {
    this.rightSidePanelService.navigateTo('cleaning-details', {jobId: cleaningId}, PastJobPage);
  }

  goToSubscriptionPage() {
    this.rightSidePanelService.navigateTo('subscription', {}, SubscriptionsPage);
  }

  getRefund(refundable) {
    if (!(refundable?.amount_to_refund > 0)) {
      this.showCantRefund();
    } else {
      this.rightSidePanelService.navigateTo('get-refund', {refundable}, GetRefundPage);
    }
  }

  showCantRefund() {
    const message = 'Unable to refund. Please contact us in the Concierge section for support.';
    this.util.showError(message, 10000);
  }

  learnAboutRefund() {
    const url = 'https://help.tidy.com/viewing-billing-history#time-to-receive-refunds';
    this.util.openUrl(url);
  }

  async waiveFee(bookingId) {
    try {
      await this.client.requestWaiveFee(bookingId);
      this.waiveFeeResults('Fee Waived');
    } catch (err) {
      this.waiveFeeResults('Unable to Waive Fee');
    }
  }

  waiveFeeResults(results) {
    const shouldShowAllToDosPage = localStorage.getItem('shouldShowAllToDosPage') === 'true';
    const params = {
      header: results,
      body: 'You can waive up to 2 cancellation fees every 10 completed cleanings. Must be within 90 days of the fee. Please click "Get Help" on the charge if you have any questions.',
      buttonText: 'Ok',
      buttonRoute: shouldShowAllToDosPage || this.windowService.isDesktopRes ? 'schedule' : 'schedule-list'
    };
    this.rightSidePanelService.navigateTo('success', params, SuccessPage);
  }

  getHelp(jobDetail) {
    if (this.windowService.isDesktopRes) {
      localStorage.setItem('chatPrefillMessage', 'I have a question about my billing: ');
      if (jobDetail) {
        localStorage.setItem('chatPrefillMetadata', JSON.stringify(jobDetail));
      }
      this.rightSidePanelService.closeRightSidePanel();
      this.navCtrl.navigateForward('chat');
    } else {
      const params = {
        title: 'Billing Help',
        type: 'support.billing',
        metadata: jobDetail
      };
      this.rightSidePanelService.navigateTo('contact-concierge', params);
    }
  }

}
